import {register} from '@shopify/theme-sections'
import $ from 'jquery'
//  import '../modules/form-validation';
import Cookies from 'js-cookie'


export default register(`template-register`, {
    onLoad() {
        const submitForm = document.getElementById(`create_customer`)
        const deleteCookie = function(name) {
            document.cookie = name + `=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`
        }
  
        submitForm.addEventListener(`submit`,()=>{
            const redirectLink = submitForm.querySelector(`[name="checkout_url"]`).value
            Cookies.set(`_redirect`,redirectLink)
        })
    },
  
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
  })